<template>
    <section class="orders-list">
        <div v-if="orders.length === 0" class="text-center py-5">
            <div class="mb-4">
                <i class="fa fa-shopping-cart fa-4x text-muted mb-3"></i>
                <h4 class="text-muted">No Orders Yet</h4>
                <p class="text-muted">Orders will appear here once you make a purchase.</p>
            </div>
        </div>

        <div v-else>
            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>Order #</th>
                            <th>Date</th>
                            <th>Status</th>
                            <th>Payment Method</th>
                            <th class="text-end">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="order in orders"
                            :key="order.id"
                        >
                            <td>
                                <a
                                    :href="order.permalink"
                                    class="fw-bold text-decoration-none"
                                >
                                    #{{ order.id }}
                                </a>
                            </td>
                            <td>
                                <span class="small">{{ order.date_created }}</span>
                            </td>
                            <td>
                                <span v-if="order.is_paid" class="badge bg-success">
                                    {{ formatStatus(order.status) }}
                                </span>
                                <span v-else-if="order.status === 'on-hold'" class="badge bg-warning text-dark">
                                    On Hold
                                </span>
                                <span v-else-if="order.status === 'pending'" class="badge bg-secondary">
                                    Pending Payment
                                </span>
                                <span v-else-if="order.status === 'cancelled'" class="badge bg-danger">
                                    Cancelled
                                </span>
                                <span v-else class="badge bg-info">
                                    {{ formatStatus(order.status) }}
                                </span>
                            </td>
                            <td>
                                <span class="small">{{ order.payment_method || '—' }}</span>
                            </td>
                            <td class="text-end">
                                <a
                                    :href="order.permalink"
                                    class="btn btn-sm btn-outline-primary me-1"
                                    title="View Order"
                                    target="_blank"
                                >
                                    <i class="fa fa-eye"></i>
                                </a>
                                <button
                                    v-if="invoiceEnabled"
                                    @click="downloadInvoice(order.id)"
                                    :disabled="downloadingOrders[order.id]"
                                    class="btn btn-sm btn-outline-secondary"
                                    title="Download Invoice"
                                >
                                    <i v-if="!downloadingOrders[order.id]" class="fa fa-download"></i>
                                    <i v-else class="fa fa-spinner fa-spin"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        props: {
            orders: {
                type: Array,
                required: true
            },
            invoiceEnabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                downloadingOrders: {}
            }
        },
        methods: {
            formatStatus(status) {
                // Convert status like 'processing' to 'Processing'
                return status.charAt(0).toUpperCase() + status.slice(1);
            },
            downloadInvoice(orderId) {
                // Set downloading state (Vue 3 reactivity - no need for $set)
                this.downloadingOrders[orderId] = true;

                // Use native XMLHttpRequest for proper blob handling
                const xhr = new XMLHttpRequest();
                xhr.open('POST', localized.ajaxurl + 'schooner_download_customer_invoice', true);
                xhr.responseType = 'blob';
                xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

                xhr.onload = () => {
                    this.downloadingOrders[orderId] = false;

                    if (xhr.status === 200) {
                        // Create download link
                        const blob = xhr.response;
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = `invoice-${orderId}.pdf`;
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                        document.body.removeChild(a);

                        toastr.success('Invoice downloaded successfully', 'Success');
                    } else {
                        console.error('Error downloading invoice:', xhr.statusText);
                        toastr.error('Failed to download invoice', 'Error');
                    }
                };

                xhr.onerror = () => {
                    this.downloadingOrders[orderId] = false;
                    console.error('Network error downloading invoice');
                    toastr.error('Failed to download invoice', 'Error');
                };

                // Send request with form data
                const params = new URLSearchParams();
                params.append('order_id', orderId);
                params.append('nonce', localized.restnonce);
                xhr.send(params.toString());
            }
        }
    }
</script>

<style scoped>
    .btn-sm {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
    }
    .me-1 {
        margin-right: 0.25rem;
    }
</style>
